/**
 * Полоса состояния соединения.
 *
 * Обрыв WebSocket не должен выглядеть как пустой экран: пользователь обязан
 * понимать, что данные могли устареть. Требование §13.5 плана.
 */

import { useAppSelector } from "@/app/hooks";

export function ConnectionBanner() {
  const connection = useAppSelector((state) => state.ui.connection);
  const stale = useAppSelector((state) => state.ui.staleAfterReconnect);

  if (connection === "open" && !stale) return null;
  if (connection === "idle" || connection === "connecting") return null;

  const message =
    connection === "reconnecting"
      ? "Соединение потеряно, переподключаемся…"
      : connection === "closed"
        ? "Нет связи с сервером"
        : "Данные могли устареть, пока не было связи";

  return (
    <div
      role="status"
      aria-live="polite"
      className="px-5 py-2 text-center text-[13px] font-semibold"
      style={{
        background: "var(--color-warning-soft)",
        color: "var(--color-warning)",
      }}
    >
      {message}
    </div>
  );
}
